import { createComponent } from '@carvana/merch-components';
import cx from 'classnames';

export const FooterBar = createComponent('div', {
  className: cx(
    'sticky -bottom-px z-10 mt-auto bg-background-strong rounded-tl-2xl rounded-tr-2xl transition-[border-radius] duration-200 ease-out',
    'sm:self-center sm:bottom-5xl sm:rounded-2xl sm:w-[840px] sm:max-w-[calc(100%-4rem)]'
  )
});

export const FooterContent = createComponent('div', {
  className: cx(
    'flex w-full flex-col gap-xl px-2xl pt-2xl pb-2xl',
    'sm:flex-row sm:items-center sm:gap-lg sm:p-3xl'
  )
});
